if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      // Lot multi-variantes (bloc "quantity_selector") : renvoie [{id, quantity}, ...] ou null
      getBundleItems() {
        const input = document.querySelector("[data-tqs-items]");
        if (!input || !input.value) return null;
        try {
          const items = JSON.parse(input.value);
          if (!Array.isArray(items) || items.length < 2) return null;
          const clean = items
            .map((it) => ({
              id: parseInt(it.id, 10),
              quantity: parseInt(it.quantity, 10) || 1,
            }))
            .filter((it) => !isNaN(it.id) && it.quantity > 0);
          return clean.length > 1 ? clean : null;
        } catch (e) {
          console.error("[product-form] bundle items illisibles", e);
          return null;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const bundleItems = this.getBundleItems();
        const sectionIds = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : null;

        let formData = null;
        if (bundleItems) {
          // Plusieurs variantes distinctes : /cart/add.js accepte un tableau items en JSON
          const payload = { items: bundleItems };
          if (sectionIds) {
            payload.sections = sectionIds;
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify(payload);
        } else {
          delete config.headers["Content-Type"];
          formData = new FormData(this.form);
          if (this.cart) {
            formData.append("sections", sectionIds);
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        this.skipCart = false;
        const variantInput = this.form.querySelector("[name=id]");
        if (variantInput?.dataset?.skipCart === "true") {
          this.skipCart = true;
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(
                `${routes.cart_add_url}`,
                this.getUpsellProductConfig()
              );
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: bundleItems
                  ? bundleItems[0].id
                  : formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: bundleItems
                  ? bundleItems[0].id
                  : formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
